import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../../services/api/endpoint";
import { Permission } from "../../../../utils/enums";
import GridPanel from "../../../global/gridpanel";
import { checkBoxCell, customCell } from "../../../global/gridpanel/customCells/gridCells";
import { IRoutedTabProps } from "../../../global/routertabpanel";
import UserEditor from "./editor";

const Users: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.UsersList}
			endpoint={Endpoint.Users}
			addScreen={UserEditor}
			editScreen={UserEditor}
			showDelete
			addPermission={Permission.UsersAdd}
			editPermission={Permission.UsersUpdate}
			deletePermission={Permission.UsersDelete}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="sequenceNumber" title={t("sequenceNumber")} width="160px" filterable={false} />
			<GridColumn field="firstName" title={t("firstName")} />
			<GridColumn field="lastName" title={t("lastName")} />
			<GridColumn field="fullName" title={t("fullName")} />
			<GridColumn field="email" title={t("email")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell(false))} />
		</GridPanel>
	);
};

export default Users;
